import DataCard from "components/Common/DataCard"
import StatusBadge from "components/Common/StatusBadge"
import PublishableOnSocialPlatformsUpdate from "./PublishableOnSocialPlatformsUpdate"
import DataBadgeCard from "components/Common/DataBadgeCard"
import ThemePlaceholder from "components/Common/ThemePlaceholder"
export default function PublishableOnSocialPlatforms({
  data = [],
  loading = false,
  stockId = null,
}) {
  const getData = () => {
    if (loading) {
      // Return 3 placeholder items while loading
      return Array.from({ length: 3 }).map((_, idx) => ({
        id: idx,
        name: (
          <ThemePlaceholder style={{ width: 80, height: 0, borderRadius: 6 }} />
        ),
      }))
    }
    return data?.map(item => item?.platform) || []
  }

  return (
    <DataBadgeCard
      data={getData()}
      name="Platforms"
      title="Publishable on Platforms"
      icon="bx bx-share-alt"
      action={
        loading ? null : (
          <PublishableOnSocialPlatformsUpdate stockId={stockId} data={data} />
        )
      }
    />
  )
}
